/**
 * Utility functions for Smart Date Recognizer
 */

/**
 * Escape regex special characters
 */
export function escRx(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Normalize 2-digit year to 4-digit (assumes 1900-2099 range)
 */
export function normY(yStr) {
    const y = parseInt(yStr, 10);
    if (y >= 0 && y <= 99) {
        return y >= 50 ? 1900 + y : 2000 + y;
    }
    return y >= 1900 && y <= 2099 ? y : null;
}

/**
 * Format date as YYYY-MM-DD
 */
export function ymd(year, month, day) {
    const pad2 = (n) => String(n).padStart(2, '0');
    return `${year}-${pad2(month)}-${pad2(day)}`;
}

